/**
 * IndexedDBのスキーマ定義
 */

export const DB_NAME = 'PreconSupporterDB';
export const DB_VERSION = 2; // v2: learnerProfileにnickname追加

/**
 * オブジェクトストア名
 */
export const STORE_NAMES = {
  LEARNING_PROGRESS: 'learningProgress',
  LEARNER_PROFILE: 'learnerProfile',
} as const;

/**
 * データベーススキーマ
 */
export interface DBSchema {
  learningProgress: {
    key: string; // id
    value: {
      id: string;
      courseId: string;
      lectureProgresses: Array<{
        lectureId: string;
        completed: boolean; // 完了状態
        completedAt: string | null; // 完了日時 (ISO 8601)
      }>;
      examinationPassed: boolean; // 修了テスト合格フラグ
      createdAt: string;
      updatedAt: string;
      passerToken?: string; // 合格者トークン
    };
    indexes: {
      courseId: string;
    };
  };
  learnerProfile: {
    key: string; // 固定キー 'default'
    value: {
      wantsAdvancedCourse: boolean; // アドバンスト編受講希望
      nickname: string | null; // ニックネーム（修了証用、1回のみ設定可能）
      createdAt: string;
      updatedAt: string;
    };
  };
}
